import { appAddMiddleWare, coreStore } from 'answers-core/src/redux/core-store';

import { portalInitMiddleware } from './middlewares/portal-init-middleware';
import { queryParamsSyncMiddleware } from './middlewares/query-params-sync-middleware';

appAddMiddleWare(portalInitMiddleware, queryParamsSyncMiddleware);

export const store = coreStore;
